import {Carousel, Dropdown, Collapse} from 'bootstrap';
import Flickity from 'flickity';
import AOS from 'aos';
import ModuloBox from './plugins/modulobox.js';
import CookieNotification from "bb-cookie-notification";
import axios from 'axios';

// Init Animate On Scroll
AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

// Outline fix background-images
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Flickity
if (document.querySelector('.review-carousel')) {
    var flkty = new Flickity( '.review-carousel', {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        arrowShape: '',
        setGallerySize: false
    });

    const slides = document.querySelectorAll('.review-carousel .review-carousel-item');
    console.log(slides);
    const handleFlickityViewportChange = () => {
        slides.forEach(slide => slide.style.height = '');

        let heights = Array.from(slides).map((slide) => slide.scrollHeight),
            max = Math.max(...heights);

        slides.forEach((slide) => slide.style.height = max + 'px');
        document.querySelector('.review-carousel .flickity-viewport').style.height = (max + 50) + 'px';
    }
    window.addEventListener('resize', handleFlickityViewportChange);
    window.addEventListener('DOMContentLoaded', handleFlickityViewportChange);

}

// Process contact form
if(document.getElementById('contact-form')) {
    const contactForm = document.getElementById('contact-form');
    contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        const formData = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        const validationAlert = document.getElementById('contact-form-validation');

        document.querySelectorAll('.invalid-feedback').forEach(element => {
            if(!element.classList.contains('d-none')) {
                element.classList.add('d-none');
            }
        });

        document.querySelectorAll('.is-invalid').forEach(element => {
            element.classList.remove('is-invalid');
        });

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('alert-danger');
        axios.post(contactForm.action, formData).then(response => {
            if(response.data.success) {
                validationAlert.innerHTML = response.data.message;
                validationAlert.classList.add('alert-success');
                validationAlert.classList.remove('d-none');

                contactForm.innerHTML = '';
            }
        }).catch(exception => {
            grecaptcha.reset();
            if(exception.response.data.errors) {
                for(let error in exception.response.data.errors) {
                    const el = contactForm.querySelector('[name="' + error + '"]');
                    el.classList.add('is-invalid');
                    if(el.parentNode.querySelector('.d-none') !== null) {
                        el.parentNode.querySelector('.d-none').classList.remove('d-none');
                    }
                }
            }
        });
    });
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

const hash = window.location.hash.replace(/^#/, '').trim();
if(hash !== '') {
    const scrollToElement = document.getElementById(hash);
    if(scrollToElement) {
        setTimeout(() => {
            scroll({
                top:      scrollToElement.offsetTop - 100,
                behavior: "smooth"
            });
        }, 500);
    }
}

// Add and remove class to nav on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    var header         = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', (gallery, index) => {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', (gallery, index) => {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

const initRecaptcha = () => {
    const recaptchaElement = document.getElementById('g-recaptcha');
    if(recaptchaElement) {
        grecaptcha.render('g-recaptcha', {
            'sitekey': recaptchaElement.dataset.sitekey
        });
    }
}
window.initRecaptcha = initRecaptcha;
